import { IbhFilterKeys } from '@hub/libs/constants';
import type { IbhFilterControl, IbhFilterValues } from '@hub/hooks/states/useIbhFilterValuesStore';
import { useTranslation } from 'next-i18next';
import { Checkbox } from '@hub/common/Checkbox/Checkbox';
import type { IbhDimensions } from '@hub/bearing-hub/common/dimensions/dimensions';

interface NutritionSectorSectionProps {
  filterValues: IbhFilterValues;
  filterControl: IbhFilterControl;
  setFilterValue: (key: IbhFilterKeys, value: string | string[] | number | boolean | undefined | IbhDimensions) => void;
  isCollapsible?: boolean;
}

export const NutritionSectorSection = ({
  setFilterValue,
  filterValues,
  filterControl,
  isCollapsible = false,
}: NutritionSectorSectionProps) => {
  const { t } = useTranslation(['category/productFilter', 'common']);

  return (
    <>
      <Checkbox
        disabled={!!filterControl[IbhFilterKeys.FDA_COMPLIANCE]}
        key={`filter_${isCollapsible ? 'collapsible_' : ''}${IbhFilterKeys.FDA_COMPLIANCE}`}
        id={`filter_${isCollapsible ? 'collapsible_' : ''}${IbhFilterKeys.FDA_COMPLIANCE}`}
        value={
          !!filterControl[IbhFilterKeys.FDA_COMPLIANCE] === true
            ? false
            : !!(filterValues[IbhFilterKeys.FDA_COMPLIANCE] as boolean | undefined)
        }
        onChange={newValue => {
          setFilterValue(IbhFilterKeys.FDA_COMPLIANCE, newValue || undefined);
        }}
        label={t(`FILTERS.LABELS.FDA_COMPLIANCE`, { ns: 'bearing-hub/bearingHub' })}
      />
      <Checkbox
        disabled={!!filterControl[IbhFilterKeys.EU102011_COMPLIANCE]}
        key={`filter_${isCollapsible ? 'collapsible_' : ''}${IbhFilterKeys.EU102011_COMPLIANCE}`}
        id={`filter_${isCollapsible ? 'collapsible_' : ''}${IbhFilterKeys.EU102011_COMPLIANCE}`}
        value={
          !!filterControl[IbhFilterKeys.EU102011_COMPLIANCE] === true
            ? false
            : !!(filterValues[IbhFilterKeys.EU102011_COMPLIANCE] as boolean | undefined)
        }
        onChange={newValue => {
          setFilterValue(IbhFilterKeys.EU102011_COMPLIANCE, newValue || undefined);
        }}
        label={t(`FILTERS.LABELS.EU102011_COMPLIANCE`, { ns: 'bearing-hub/bearingHub' })}
      />
    </>
  );
};
